import React, { Component } from 'react';
import { Collapse } from 'react-collapse';

import {
  getItemPresentation,
  groupItemsByStation,
  getItemMeatPresentation,
} from '../../utils/Helpers';


const ItemRow = ({item, error, handleBackOrderChange}) => {
  const presentation = getItemPresentation(item.item);
  return (
    <tr className={`${error ? 'error-row' : ''}`}>
      <td>{item.name} {item.grade !== null ? `(Grade: ${item.grade})` : ''}</td>
      <td>{presentation ? presentation : getItemMeatPresentation(item.item, item.presentation)}</td>
      <td>{item.amount}</td>
      <td>
        <input
          checked={item.in_back_order}
          onChange={(event) => handleBackOrderChange(item.id, event.target.checked)}
          type="checkbox"
        />
      </td>
    </tr>
  )
}

const ButcherRow = ({ item, error, handleBackOrderChange, openChangeSubstituteItemModal }) => {
  const presentation = getItemPresentation(item.item);
  return (
    <tr className={`${error && "error-row"}`}>
      <td>
        {item.name} {item.grade !== null ? `(Grade: ${item.grade})` : ""}
      </td>
      <td>{presentation ? presentation : getItemMeatPresentation(item.item, item.presentation)}</td>
      <td>{item.amount}</td>
      <td>
        <div className="d-flex align-self-center">
          <input checked={item.in_back_order} onChange={(event) => handleBackOrderChange(item.id, event.target.checked)} type="checkbox" />
          <i className="ml-1 mr-0 cursor-pointer fa fa-edit" onClick={() => openChangeSubstituteItemModal(item.item, item.grade, item.amount)} />
        </div>
      </td>
    </tr>
  );
};

class StationItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showItems: true,
    }
  }

  toggleItems = () => {
    this.setState((prevState) => ({
      showItems: !prevState.showItems
    }));
  }

  render() {
    const { station, items, errors, handleBackOrderChange, openChangeSubstituteItemModal } = this.props;
    const { showItems } = this.state;
    return (
      <tbody>
        <tr className="grouped-table-section-name pointer" onClick={this.toggleItems}>
          <td colSpan="4">
            <div className="d-flex justify-content-between">
              <span>{station} ({items.length})</span>
              <i className={`fa ${showItems ? "fa-chevron-up" : "fa-chevron-down"}`}/>
            </div>
          </td>
        </tr>
        {showItems &&
          (station === "Butcher"
            ? items.map((item) => {
                return (
                  <ButcherRow
                    item={item}
                    key={item.id}
                    error={errors.indexOf(item.id) !== -1}
                    handleBackOrderChange={handleBackOrderChange}
                    openChangeSubstituteItemModal={openChangeSubstituteItemModal}
                  />
                );
              })
            : items.map((item) => {
                return (
                  <ItemRow item={item} key={item.id} error={errors.indexOf(item.id) !== -1} handleBackOrderChange={handleBackOrderChange} />
                );
              }))}
      </tbody>
    )
  }
}


export default class ShipmentItemsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAccordionOpen: true,
    }
  }

  toggleAccordion = () => {
    this.setState((prevState) => {
      return {
        isAccordionOpen: !prevState.isAccordionOpen,
      }
    })
  }

  render() {
    const { items, itemsAdded, errors, handleBackOrderChange, openChangeSubstituteItemModal } = this.props;
    const { isAccordionOpen } = this.state;
    const totalCount = items.length;
    const pendingItems = items.filter((item) => {
      return itemsAdded.indexOf(item.item.id) === -1;
    });
    const pendingCount = pendingItems.length;
    const itemsByStation = groupItemsByStation(pendingItems);
    const stationsWithItems = Object.keys(itemsByStation);
    return (
      <div className="card mt-2">
        <div className="card-header-grey p-1 d-flex justify-content-between pointer" onClick={this.toggleAccordion}>
          <div className="d-flex align-items-end">
            <strong>Order items:</strong>
            <div className="d-flex ml-2 align-items-end">
              <h4 className="m-0 mr-025">{totalCount - pendingCount}</h4><span> Scanned</span>
            </div>
            <div className="d-flex ml-2 align-items-end">
              <h4 className="m-0 mr-025">{pendingCount}</h4><span> Remain</span>
            </div>
          </div>
          <div className="row m-0">
            <div className="shipment-package-collapse">
              <i className={`fa ${isAccordionOpen ? "fa-caret-up" : "fa-caret-down"}`}></i>
            </div>
          </div>
        </div>
        <Collapse isOpened={isAccordionOpen}>
        <div className="card-block p-0">
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>Item</th>
                <th className="hidden-xs-down">Presentation</th>
                <th className="hidden-sm-up">Pres</th>
                <th>Qty</th>
                <th>Back Order</th>
              </tr>
            </thead>
            {stationsWithItems.map((station) => {
              return (
                <StationItems
                  key={station}
                  station={station}
                  items={itemsByStation[station]}
                  errors={errors}
                  handleBackOrderChange={handleBackOrderChange}
                  openChangeSubstituteItemModal={openChangeSubstituteItemModal}
                />
              )
            })}
          </table>
        </div>
        </Collapse>
      </div>
    );
  }

}
